import { defineComponent as _defineComponent } from 'vue'
import HealthIndicator from '@/components/careConsole/HealthIndicator.vue';
import {
  DeviceElementHealthData,
  HealthChartsData,
} from '@/models/Charts/chartsData';
import { isEmpty } from '@/utils/misc';
import { HealthTimelineGenerator } from '@/models/Charts/healthTimelineGenerator';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HealthIndicatorsContainer',
  props: {
    data: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n();

function getKpis(dataItem: DeviceElementHealthData): Record<string, number> {
  const kpis: Record<string, number> = {
    max: dataItem.max,
    average: dataItem.average,
    median: dataItem.median,
    min: dataItem.min,
  };

  if (dataItem.filteredMax) {
    kpis['filteredMax'] = dataItem.filteredMax;
  }

  return kpis;
}

// FIXME: We should be able to inline this code into the template, but it
// seems unit tests are using a different SFC parser. We should be able to
// fix this by using the same package versions as in the DataPlatform project.
function getValue(dataItem: DeviceElementHealthData) {
  // We show filteredMax on all indicators but the Drawer cycles one
  return dataItem?.filteredMax ?? dataItem?.max ?? 0;
}

function getLevelMaximums(dataItem: DeviceElementHealthData): number[] {
  return [dataItem.a, dataItem.b, dataItem.c, dataItem.d, dataItem.e];
}

function showDecimals(dataItem: DeviceElementHealthData): boolean {
  return ['temperatures', 'lensDrive'].includes(dataItem.deviceElement);
}

function getUnit(dataItem: DeviceElementHealthData): string {
  return HealthTimelineGenerator.getUnit(
    dataItem.deviceElement as keyof HealthChartsData,
  );
}

return { __sfc: true,t, getKpis, getValue, getLevelMaximums, showDecimals, getUnit, HealthIndicator, isEmpty }
}

})